var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 324,
    viewBox: "0 0 35 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56774 56.6966L4.31528 73.4601L22.1361 0.936818L18.2833 0.878795L4.56774 56.6966ZM8.98201 0.738717L5.17728 16.2222L5.41127 0.684942L8.98201 0.738717ZM31.4372 1.07689L3.70573 113.935L3.45327 130.698L35.2901 1.13492L31.4372 1.07689ZM44.5913 1.27499L2.84373 171.172L2.59127 187.936L48.4441 1.33302L44.5913 1.27499ZM57.7454 1.47309L1.98173 228.41L1.72926 245.175L61.5982 1.53112L57.7454 1.47309ZM70.8994 1.67119L1.11973 285.648L0.867253 302.413L74.7523 1.72922L70.8994 1.67119ZM79.0981 22.0372L5.21322 322.718L9.06601 322.777L78.8456 38.8007L79.0981 22.0372ZM78.2361 79.2751L18.3673 322.917L22.22 322.975L77.9836 96.0387L78.2361 79.2751ZM77.3741 136.513L31.5212 323.115L35.3741 323.173L77.1216 153.277L77.3741 136.513ZM76.5121 193.751L44.6753 323.313L48.5281 323.371L76.2596 210.515L76.5121 193.751ZM75.6501 250.988L57.8294 323.511L61.6822 323.569L75.3976 267.753L75.6501 250.988ZM74.7881 308.226L70.9834 323.709L74.5541 323.763L74.7881 308.226Z",
    fill: "#008894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRight);
export default __webpack_public_path__ + "static/media/pattern-right.ad4d2a2f21e0e6e872d0d8de0d09cdfb.svg";
export { ForwardRef as ReactComponent };